import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;
export const supportButtonSelector = (state: RootState) => state.supportButton;
